import { useTranslation } from 'react-i18next';

type ProductOrSectorSpecificRulesProps = {
  rules: string[];
};

// Component to display the product or sector specific rules as a single text, pipe separated
const ProductOrSectorSpecificRules = (props: ProductOrSectorSpecificRulesProps): JSX.Element => {
  const { rules } = props;

  const { t } = useTranslation();

  const rulesList = (rules ?? []).filter(Boolean);

  if (!rulesList.length) {
    return <span className='text-black-alpha-60'>{t('global.notSpecified')}</span>;
  }

  return <span className='text-black-alpha-60'>{rulesList.join(' | ')}</span>;
};

export default ProductOrSectorSpecificRules;
